export default "__VITE_ASSET__cIQuKps7__"